module.exports = __webpack_public_path__ + "img/04.2314682e.png";